/**
 * Data parsing utilities for tags and authors
 */

/**
 * Get the correct predictions CSV file based on environment and user preference
 * @param {boolean} forcePrivate - Force loading private dataset (dev mode only)
 * Development: can toggle between private/public
 * Production: always loads public
 */
export const getPredictionsDataPath = (forcePrivate = false) => {
  const isDev = process.env.NODE_ENV === 'development';
  
  // Production always uses public
  if (!isDev) {
    return '/data/predictions_public.csv';
  }
  
  // Development can toggle
  return forcePrivate 
    ? '/data/predictions_private.csv'
    : '/data/predictions_public.csv';
};

/**
 * Parse tags or authors from various formats (array string, CSV, pipe-separated)
 * @param {string} value - The value to parse
 * @returns {Array<string>} Array of parsed values
 */
export const parseTagsOrAuthors = (value) => {
  if (!value) return [];
  
  try {
    // Handle array format like "['tag1', 'tag2']"
    return JSON.parse(value.replace(/'/g, '"'))
      .map(item => item.trim())
      .filter(item => item);
  } catch {
    // Fallback: treat as string and split by pipe or comma
    return value
      .split(/[|,]/)
      .map(item => item.trim())
      .filter(item => item);
  }
};

